import { MAU_DU_LIEU_MAC_DINH } from './mauDuLieu.js';

export interface AvatarProps {
  name: string;
  /** Mã màu nền, ví dụ `#4F46E5`. */
  color?: string;
  size?: number;
  className?: string;
  /**
   * Hình **vuông bo 8px** thay vì tròn. Dùng cho ảnh đại diện kênh: kênh là một
   * thứ, không phải một người — hình tròn trong app này dành cho người.
   */
  vuong?: boolean;
}

export function chuCaiDau(name: string): string {
  const tu = name.trim().split(/\s+/).filter(Boolean);
  if (tu.length === 0) return '?';
  if (tu.length === 1) return (tu[0] ?? '').slice(0, 1).toUpperCase();
  return ((tu[0] ?? '').slice(0, 1) + (tu[1] ?? '').slice(0, 1)).toUpperCase();
}

export function Avatar({
  name,
  color = MAU_DU_LIEU_MAC_DINH,
  size = 36,
  className = '',
  vuong = false,
}: AvatarProps) {
  return (
    <span
      className={`inline-flex shrink-0 items-center justify-center font-semibold text-white ${
        vuong ? 'rounded-o' : 'rounded-full'
      } ${className}`}
      style={{
        width: size,
        height: size,
        backgroundColor: color,
        fontSize: Math.round(size * 0.4),
      }}
      aria-hidden="true"
    >
      {chuCaiDau(name)}
    </span>
  );
}
